<template>
<div class="logo-holder">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" viewBox="0 0 86 65" enable-background="new 0 0 86 65" xml:space="preserve">
        <path fill="#ffffff" opacity="1.000000" stroke="none" d="
M61.000015,66.000000 

C40.699562,66.000000 20.899118,66.000000 1.049337,66.000000 

C1.049337,44.402245 1.049337,22.804354 1.049337,1.103230 

C29.549976,1.103230 58.100452,1.103230 86.825462,1.103230 

C86.825462,22.665503 86.825462,44.332649 86.825462,66.000000 

C78.471802,66.000000 69.985909,66.000000 61.000015,66.000000 
M22.596430,23.604317 

C29.643328,23.735271 31.786652,25.245565 33.541039,32.190411 

C31.847672,35.206814 30.154308,38.223217 27.986412,42.084908 

C31.275557,42.084908 33.232323,42.084908 35.125355,42.821857 

C31.690578,47.297161 27.247795,48.514439 23.107084,46.114738 

C19.539658,44.047279 18.310722,39.340195 20.188116,34.603958 

C20.671696,33.384003 21.414330,32.266731 22.594622,30.883276 

C22.396526,30.553148 22.198429,30.223019 21.150537,29.562595 

C18.151690,30.330200 13.638432,30.122932 12.410465,32.030506 

C6.400368,41.366863 13.836045,54.892159 25.017616,55.920414 

C35.676250,56.900574 39.841110,54.011024 44.741852,41.763264 

C45.407223,43.403885 45.888794,44.566460 46.351608,45.736446 

C49.703594,54.210217 56.588867,57.672539 66.189529,55.707760 

C73.749321,54.160648 79.025124,47.433311 78.947952,39.439087 

C78.860603,30.390846 76.420181,28.484880 66.964310,30.079870 

C71.330200,37.722332 71.079918,43.649025 66.282242,46.231243 

C61.727871,48.682514 57.118553,47.116665 55.007450,42.152977 

C56.253204,42.020542 57.498959,41.888103 59.571003,41.667824 

C57.724026,38.635391 56.167843,36.080399 54.727905,32.828335 

C56.815136,25.949738 61.303730,22.459879 69.776054,23.828049 

C65.666939,18.895433 62.437096,15.018302 58.086773,9.796135 

C66.387337,9.796135 73.193092,9.796135 79.998848,9.796135 

C79.954918,9.324364 79.910980,8.852592 79.867050,8.380821 

C68.968231,8.380821 58.069416,8.380821 46.212395,8.380821 

C50.375965,13.189958 53.983009,17.356279 57.711826,21.663248 

C55.164764,23.318438 52.960243,24.751026 50.347221,25.648443 

C48.264072,22.127403 46.180923,18.606363 43.708794,14.427850 

C41.422733,18.467127 39.564144,21.751093 37.065762,24.843798 

C35.381031,23.849728 33.696304,22.855656 31.801195,21.737452 

C35.682430,17.247112 39.372417,12.978030 43.151711,8.605632 

C31.738997,8.605632 20.897390,8.605632 10.055785,8.605632 

C10.043615,9.120317 10.031446,9.635000 10.019276,10.149685 

C16.698984,10.149685 23.378693,10.149685 31.001463,10.149685 

C27.401289,14.683300 24.635130,18.166658 21.265209,22.009359 

C21.475182,22.436207 21.685154,22.863054 22.596430,23.604317 
z" />
        <path fill="#0A0909" opacity="1.000000" stroke="none" d="
M21.868973,21.650015 

C24.635130,18.166658 27.401289,14.683300 31.001463,10.149685 

C23.378693,10.149685 16.698984,10.149685 10.019276,10.149685 

C10.031446,9.635000 10.043615,9.120317 10.055785,8.605632 

C20.897390,8.605632 31.738997,8.605632 43.151711,8.605632 

C39.372417,12.978030 35.682430,17.247112 31.801195,21.737452 

C33.696304,22.855656 35.381031,23.849728 37.516739,25.270376 

C40.304855,28.864466 42.641994,32.031979 44.756699,34.898026 

C46.550507,32.292271 48.653118,29.237942 50.755726,26.183617 

C52.960243,24.751026 55.164764,23.318438 57.711826,21.663248 

C53.983009,17.356279 50.375965,13.189958 46.212395,8.380821 

C58.069416,8.380821 68.968231,8.380821 79.867050,8.380821 

C79.910980,8.852592 79.954918,9.324364 79.998848,9.796135 

C73.193092,9.796135 66.387337,9.796135 58.086773,9.796135 

C62.437096,15.018302 65.666939,18.895433 69.776054,23.828049 

C61.303730,22.459879 56.815136,25.949738 54.419739,33.464104 

C54.150440,36.778690 54.189304,39.457508 54.228168,42.136326 

C57.118553,47.116665 61.727871,48.682514 66.282242,46.231243 

C71.079918,43.649025 71.330200,37.722332 66.964310,30.079870 

C76.420181,28.484880 78.860603,30.390846 78.947952,39.439087 

C79.025124,47.433311 73.749321,54.160648 66.189529,55.707760 

C56.588867,57.672539 49.703594,54.210217 46.351608,45.736446 

C45.888794,44.566460 45.407223,43.403885 44.741852,41.763264 

C39.841110,54.011024 35.676250,56.900574 25.017616,55.920414 

C13.836045,54.892159 6.400368,41.366863 12.410465,32.030506 

C13.638432,30.122932 18.151690,30.330200 21.581387,30.030220 

C22.020809,30.699327 22.029385,30.900810 22.037958,31.102291 

C21.414330,32.266731 20.671696,33.384003 20.188116,34.603958 

C18.310722,39.340195 19.539658,44.047279 23.107084,46.114738 

C27.247795,48.514439 31.690578,47.297161 35.426079,42.158676 

C35.173664,38.226105 34.620525,34.956718 34.067387,31.687330 

C31.786652,25.245565 29.643328,23.735271 22.250914,23.036951 

C21.893255,22.196394 21.881113,21.923204 21.868973,21.650015 
z" />
        <path fill="#F5AE46" opacity="1.000000" stroke="none" d="
M50.551476,25.916029 

C48.653118,29.237942 46.550507,32.292271 44.756699,34.898026 

C42.641994,32.031979 40.304855,28.864466 37.836636,25.366007 

C39.564144,21.751093 41.422733,18.467127 43.708794,14.427850 

C46.180923,18.606363 48.264072,22.127403 50.551476,25.916029 
z" />
        <path fill="#EDAB49" opacity="1.000000" stroke="none" d="
M33.804214,31.938869 

C34.620525,34.956718 35.173664,38.226105 35.457947,41.790199 

C33.232323,42.084908 31.275557,42.084908 27.986412,42.084908 

C30.154308,38.223217 31.847672,35.206814 33.804214,31.938869 
z" />
        <path fill="#E3A74C" opacity="1.000000" stroke="none" d="
M54.617809,42.144653 

C54.189304,39.457508 54.150440,36.778690 54.361618,33.812637 

C56.167843,36.080399 57.724026,38.635391 59.571003,41.667824 

C57.498959,41.888103 56.253204,42.020542 54.617809,42.144653 
z" />
        <path fill="#0A0A09" opacity="1.000000" stroke="none" d="
M21.567091,21.829687 

C21.881113,21.923204 21.893255,22.196394 21.900261,22.879744 

C21.685154,22.863054 21.475182,22.436207 21.567091,21.829687 
z" />
        <path fill="#0A0A09" opacity="1.000000" stroke="none" d="
M22.316290,30.992783 

C22.029385,30.900810 22.020809,30.699327 22.006285,30.195366 

C22.198429,30.223019 22.396526,30.553148 22.316290,30.992783 
z" />
    </svg>
</div>
</template>

<script>
export default {
    name: 'white-logo'
}
</script>

<style>
.logo-holder {
    max-width: 200px
}
</style>